export default function LoadingScreen({ message = "A Joy está preparando tudo..." }) {
  return (
    <div
      data-testid="loading-screen"
      className="min-h-screen w-full flex items-center justify-center"
    >
      <div className="flex flex-col items-center gap-5 text-center px-8">
        <div className="relative">
          <img
            src="/joy.png"
            alt="Joy"
            className="w-28 h-28 rounded-full object-cover border-4 border-[#FF69B4] joy-bob"
            style={{ boxShadow: "0 10px 24px rgba(255,105,180,0.35)" }}
          />
          <span className="absolute -top-2 -right-2 text-2xl joy-twinkle">✨</span>
        </div>
        <div className="flex gap-2">
          <span className="w-3 h-3 rounded-full bg-[#FF69B4] joy-pulse-heart" style={{ animationDelay: "0s" }} />
          <span className="w-3 h-3 rounded-full bg-[#FFD700] joy-pulse-heart" style={{ animationDelay: "0.2s" }} />
          <span className="w-3 h-3 rounded-full bg-[#40E0D0] joy-pulse-heart" style={{ animationDelay: "0.4s" }} />
        </div>
        <p className="font-bold text-[#8B7355]">{message} 🦊💕</p>
      </div>
    </div>
  );
}
